export default __webpack_public_path__ + "static/media/bkg-home.a9bcbadb.svg";